var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import "../../FormikForm.js";
import "../../Panel/index.js";
import { CreateEntityBase } from "../Base/CreateEntityBase.js";
import "../../../Styling.js";
import { getTheme } from "@fluentui/style-utilities";
import { Panel } from "../../Panel/Panel.js";
import { PanelType } from "@fluentui/react/lib/Panel";
import { FormikForm } from "../../FormikForm/FormikForm.js";
const gutterSize = 20;
const formId = "ane-entity-panel-form";
const CreateEntityPanel = (props) => {
  const theme = getTheme();
  const _a = props, {
    stickyHeader = false,
    formHeadingStyles: formHeadingStylesProps = { root: {} },
    isContentRelative = false
  } = _a, restProps = __objRest(_a, [
    "stickyHeader",
    "formHeadingStyles",
    "isContentRelative"
  ]);
  return /* @__PURE__ */ jsx(
    CreateEntityBase,
    __spreadValues({
      formId,
      onRenderBaseComponent: ({ isOpen, renderHeader, renderFooter, cancelForm, onDismissed, renderContent }) => {
        var _a2;
        return /* @__PURE__ */ jsx(
          Panel,
          __spreadProps(__spreadValues({
            isOpen,
            type: PanelType.medium,
            styles: {
              content: __spreadValues({
                paddingLeft: gutterSize,
                paddingRight: gutterSize
              }, isContentRelative ? { position: "relative" } : {}),
              contentInner: { height: "100%" },
              scrollableContent: { height: "100%" },
              commands: stickyHeader && !((_a2 = props.panelProps) == null ? void 0 : _a2.hasCloseButton) ? { position: "sticky", top: 0, zIndex: 1, padding: 0 } : void 0
            },
            onRenderHeader: renderHeader,
            onRenderFooter: renderFooter,
            onDismiss: cancelForm,
            onDismissed,
            hasCloseButton: false,
            isFooterAtBottom: true,
            isLightDismiss: false
          }, props.panelProps), {
            children: /* @__PURE__ */ jsx(FormikForm, { id: formId, children: renderContent() })
          })
        );
      },
      formHeadingStyles: __spreadProps(__spreadValues({}, formHeadingStylesProps), {
        root: __spreadValues(__spreadProps(__spreadValues({}, (formHeadingStylesProps == null ? void 0 : formHeadingStylesProps.root) || {}), {
          paddingLeft: gutterSize,
          paddingRight: gutterSize
        }), stickyHeader ? {
          position: "sticky",
          top: 0,
          zIndex: 1,
          padding: `8px ${gutterSize}px`,
          backgroundColor: theme.semanticColors.bodyBackground
        } : {})
      })
    }, restProps)
  );
};
export {
  CreateEntityPanel
};
//# sourceMappingURL=CreateEntityPanel.js.map
